// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "Tree" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { TreeType } from "./tree-type.enum.gen";

export const TreeGenShape = z.strictObject({
  name: z.string(),
  type: z.enum(TreeType),
  startText: z.string(),
  contactText: z.string().optional(),
  disclaimer: z.string().optional(),
  noticeTitle: z.string().optional(),
  noticeHtml: z.string().optional(),
  libraryId: z.string(),
  created: z.string().optional(),
  createdUserId: z.string().optional(),
  lastEdited: z.string().optional(),
  lastEditedUserId: z.string().optional(),
  id: z.string(),
});
